// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yYSN6Gz6m2KzjMoxqchj{width:100%;height:100%;display:flex;justify-content:center;align-items:center}.yYSN6Gz6m2KzjMoxqchj .zGpQnO8Fgpd1sDfv2Klz{height:100%;display:flex;justify-content:center;flex-direction:column;align-items:center;overflow:hidden}.yYSN6Gz6m2KzjMoxqchj .zGpQnO8Fgpd1sDfv2Klz h2{margin-bottom:0;margin-top:1rem}.yYSN6Gz6m2KzjMoxqchj .zT5lNXXO7xP4hyvdd0PO{margin-top:1rem;margin-bottom:1rem}.yYSN6Gz6m2KzjMoxqchj .JlJHyIhW1rFBh96QZ8oj i{color:#6e32f0 !important}.yYSN6Gz6m2KzjMoxqchj .q9uYFHqrAaett4pH7DtV{color:#6e32f0;text-align:center;font-size:15px;font-weight:600;margin-bottom:2rem;letter-spacing:.7rem;text-transform:uppercase}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"container": `yYSN6Gz6m2KzjMoxqchj`,
	"carouselItem": `zGpQnO8Fgpd1sDfv2Klz`,
	"buttonContainer": `zT5lNXXO7xP4hyvdd0PO`,
	"button": `JlJHyIhW1rFBh96QZ8oj`,
	"title": `q9uYFHqrAaett4pH7DtV`
};
export default ___CSS_LOADER_EXPORT___;
